import React, { useEffect, useState } from "react";
import HeroSection from "../components/HeroSection";
import FillerSection from "../components/FillerSection";
import ChunkyMenuToggle from "../components/ChunkyMenuToggle"; 
import GlobalFooter from "../components/GlobalFooter";
import ServicesSection from "../components/ServiceSection";
import BottomCTA from "../components/ButtonCTA";
import HomeMedia from "../components/HomeMedia";
import ServicesOfferedFull from "../components/ServicesOfferedFull";
import TeaserSection1 from "../components/TeaserSection1";
import HomepageSection2 from "../components/HomepageSection2";

export default function Homepage({ isMenuOpen, toggleMenu }) {
  const [showChunky, setShowChunky] = useState(true);

  useEffect(() => {
    const handleScroll = () => {
      const hero = document.querySelector("#hero");
      const heroHeight = hero?.offsetHeight || window.innerHeight;
      const pastHero = window.scrollY > heroHeight - 60;
      setShowChunky(!pastHero);
    };

    window.addEventListener("scroll", handleScroll);
    handleScroll(); //  Run once on mount

    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <div className="relative">
      <HeroSection isMenuOpen={isMenuOpen} toggleMenu={toggleMenu} />

      {/* Only shows on hero, only desktop */}
      {showChunky && (
        <div className="hidden md:block fixed top-10 right-20 z-[100]">
          <ChunkyMenuToggle isOpen={isMenuOpen} toggleMenu={toggleMenu} />
        </div>
      )}

      <HomepageSection2 />
      <HomeMedia />
      <TeaserSection1/>
      <ServicesOfferedFull />
      <div className="bg-strobe-black">
  <BottomCTA />
</div>

      <GlobalFooter />
    </div>
  );
}



